import { apiUrls } from './index';
import { consts } from '../utils/consts';
import { http } from './fetch-wrapper';

export async function proFind({ authData, bodyParams }) {
  try {
    const headers = new Headers();

    headers.append('Authorization', authData);
    headers.append('Content-Type', 'application/json');

    const requestOptions = {
      headers,
      method: 'POST',
      body: JSON.stringify(bodyParams),
    };

    const response = await fetch(apiUrls.USERS_PRO_FIND, requestOptions);

    if (response.status === 401) {
      return {};
    }

    return await response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export function logIn(authData) {
  const headers = new Headers();

  headers.append('Authorization', authData);

  return http(apiUrls.LOG_IN, { method: 'GET', headers });
}

export function logOut(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Device', localStorage.getItem('uuid'));

  return http(apiUrls.LOG_IN, { method: 'DELETE', headers });
}

export function getCalls(authData, isProCalls, sort = 'activity', q = '', page = 0) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  const query = `&sort=${sort}&q=${q}&page=${page - 1}&size=${consts.PAGE_SIZE}`;
  return http((isProCalls ? apiUrls.GET_PRO_CALLS : apiUrls.GET_PERSONAL_CALLS) + query, { method: 'GET', headers });
}

export function getCallHistory(id, isPro = false, page, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  let additionalQuery = `?isPro=${isPro}`;

  if (page) {
    additionalQuery = `${additionalQuery}&page=${page}`;
  }

  return http(apiUrls.CALL_HISTORY(id) + additionalQuery, { method: 'GET', headers });
}

export function getTransactions(authData, num, page) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);
  const additionalQuery = num && page ? `?size=${num}&page=${page - 1}` : '';

  return http(apiUrls.GET_TRANSACTIONS + additionalQuery, { method: 'POST', headers });
}

export function getWithdraw(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.PAYOUT_V3, { method: 'GET', headers });
}

export function editDetails(data, userAuth) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', userAuth);

  return http(apiUrls.EDIT_DETAILS, { method: 'PUT', headers, body: JSON.stringify(data) });
}

export function switchData(url, isOn, userAuth) {
  const headers = new Headers();
  headers.append('Authorization', userAuth);

  return http(url, { method: isOn ? 'POST' : 'DELETE', headers });
}

export function verify(token) {
  return http(
    `${apiUrls.VERIFY_USER}?token=${token}`,
    { method: 'GET' },
  )
    .then((response) => ({
      authData: window.btoa(`${response.email}:${response.password}`),
    }));
}

export function register(data) {
  const headers = new Headers();

  headers.append('Content-Type', 'application/json ');

  return http(apiUrls.REGISTER, { method: 'POST', headers, body: JSON.stringify(data) });
}

export function getUserInfo(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.GET_V3_CURRENT_USER_DETAILS, { method: 'GET', headers });
}

export function registerPro(data, authData) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return http(apiUrls.REGISTER_PRO(data.id), { method: 'POST', headers, body: JSON.stringify(data) });
}

export function getProRegistrationInfo(id, authData) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return http(apiUrls.REGISTER_PRO(id), { method: 'GET', headers });
}

export function cancelProPending(id, authData) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return http(apiUrls.REGISTER_PRO(id), { method: 'DELETE', headers });
}

export function registerProUser(data, authData) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);
  const body = JSON.stringify(data);

  return http(apiUrls.REGISTER_PRO_USER, { method: 'POST', headers, body });
}

export function getProUserRegistrationInfo(authData, approved = false) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', authData);

  return http(`${apiUrls.REGISTER_PRO_USER}?approved=${approved}`, { method: 'GET', headers });
}

export function cancelProUserPending(authData) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');
  headers.append('Authorization', authData);

  return http(apiUrls.REGISTER_PRO_USER, { method: 'DELETE', headers });
}

export function getCategories(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.GET_CATEGORIES, { method: 'GET', headers });
}

export function resetPassword(data) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');

  return http(apiUrls.RESET_PASSWORD, { method: 'POST', headers, body: JSON.stringify(data) });
}

export function uploadPhoto(authData, photo, filName) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  const body = new FormData();
  body.append('file', photo, filName);

  return http(apiUrls.UPLOAD_PHOTO, { method: 'POST', headers, body });
}

export function sendContactData(data) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json ');

  return http(apiUrls.SEND_CONTACT_DATA, { method: 'PUT', headers, body: JSON.stringify(data) });
}

export function checkTaxId(taxId, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.GET_COMPANY_TAX_ID(taxId), { method: 'GET', headers });
}

export function authWithSocialNetwork(providerId, authData, partner) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.OAUTH2(providerId, partner), { method: 'GET', headers });
}

export function setUserState(key, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.SET_STATE(key), { method: 'PUT', headers });
}

export function removeUserState(key, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.REMOVE_STATE(key), { method: 'DELETE', headers });
}

export function getAvailability(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.AVAILABILITY, { method: 'GET', headers });
}

export function deleteAvailability(authData, data) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return http(apiUrls.AVAILABILITY, {
    method: 'DELETE',
    headers,
    body: JSON.stringify({
      ...data,
    }),
  });
}

export function setAvailability(authData, { msFrom, msTo, daysList }) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return http(apiUrls.AVAILABILITY, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      msFrom,
      msTo,
      daysList,
    }),
  });
}
export function updateAvailability(authData, data) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return http(apiUrls.AVAILABILITY, {
    method: 'PUT',
    headers,
    body: JSON.stringify({
      msFrom: data.msFrom,
      msTo: data.msTo,
      daysList: data.daysList,
      id: data.id,
    }),
  });
}

let userSettingController = new AbortController();
let requestSend = false;

export function updateUserSettings(authData, settings) {
  if (requestSend) {
    requestSend = false;
    userSettingController.abort();
    userSettingController = new AbortController();
  }
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');
  requestSend = true;

  return http(apiUrls.USER_SETTINGS, {
    method: 'PUT', headers, body: JSON.stringify(settings), signal: userSettingController.signal,
  }).then((response) => {
    requestSend = false;
    return response;
  });
}

export function getDeepLink(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.DEEP_LINK, { method: 'GET', headers });
}

export function unreadMessagesController(authData, id) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.BADGE(id), { method: id ? 'POST' : 'GET', headers });
}

export function addDeviceForCurrentUser(authData, body) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return http(apiUrls.DEVICE(), { method: 'POST', headers, body: JSON.stringify(body) });
}

export function updateDeviceForCurrentUser(authData, deviceId, body) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return http(apiUrls.DEVICE(deviceId), { method: 'PUT', headers, body: JSON.stringify(body) });
}

export async function checkAppMinVersionSupport(type, version) {
  const response = await fetch(apiUrls.VERSION(type, version), { method: 'POST' });
  if (response.status === 200 || response.status === 400) return response.ok;

  const responseJson = await response.json();

  throw new Error(responseJson.error);
}

let getProsController = new AbortController();
let requestGetProsSend = false;

export async function sharePro(authData, query) {
  if (requestGetProsSend) {
    requestGetProsSend = false;
    getProsController.abort();
    getProsController = new AbortController();
  }
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  // eslint-disable-next-line no-return-await
  return await http(apiUrls.SHARE(query), { method: 'GET', headers, signal: getProsController.signal }).then((response) => {
    requestGetProsSend = false;
    return response;
  });
}

export async function refreshToken(accessToken, refreshTokenStr, tokenType = 'Bearer') {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const body = JSON.stringify({
    accessToken,
    refreshToken: refreshTokenStr,
    tokenType,
  });

  return http(apiUrls.REFRESH, { method: 'POST', headers, body });
}

export function proShare({ authData, query }) {
  const headers = new Headers();

  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  const options = {
    headers,
    method: 'GET',
  };

  return http(apiUrls.USERS_PRO_SHARE(query), options);
}



// WEBPACK FOOTER //
// ./api/users.js